import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Pagination from "../../Components/Pagination/Pagination";
import { toast } from "react-toastify";
import Select from "react-select";
import closeIcon from "../../assets/icons/close.svg";
import "../../assets/css/addunit.css";

const UsageReview = () => {
  const [usecases, setUsecases] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUsecase, setSelectedUsecase] = useState(null);
  const [spvMappings, setSpvMappings] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const navigate = useNavigate();

  // -------------------------------------------------------
  const [masterOptionsMap, setMasterOptionsMap] = useState({});
  const [errorrowMessages, setErrorrowMessages] = useState([]);
  const [editRowTemplateId, setEditRowTemplateId] = useState(null);
  const [assets, setAssets] = useState([]);
  const [assetId, setAssetId] = useState("");
  const [assetAttributes, setAssetAttributes] = useState([]);
  const [assetTemplates, setAssetTemplates] = useState([]);

  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editRowValues, setEditRowValues] = useState({});

  const [templateMasters, setTemplateMasters] = useState({});
  const [assetMasters, setAssetMasters] = useState([]);

  const [formValues, setFormValues] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [rows, setRows] = useState({});

  const [errforsubmit, seterrforsubmit] = useState("");
  const [errors, setErrors] = useState({});


  const { equipment_id } = useParams();
  const [errorMessages, setErrorMessages] = useState([]);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);



  const customStyles = {
      control: (base, state) => ({
          ...base,
          height: "48px",
          width: "250px",
          minHeight: "48px",
          lineHeight: "30px",
          borderRadius: "12px",
          boxShadow: state.isFocused ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none",
          borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
          "&:hover": {
              borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
          },
      }),
      menu: (provided) => ({
          ...provided,
          zIndex: 9999,
      }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menuList: (base) => ({
          ...base,
          padding: 0,
          maxHeight: "300px",
          overflowY: "auto",
      }),
      option: (base, state) => ({
          ...base,
          padding: "10px",
          color: "#171717",
          backgroundColor:
              state.isSelected || state.isFocused ? "#f4f4f4" : "white",
          cursor: "pointer",
          "&:hover": {
              backgroundColor: "#f0f0f0",
          },
          lineHeight: "15px",
      }),
      placeholder: (base) => ({
          ...base,
          lineHeight: "15px",
      }),
      input: (base) => ({
          ...base,
          lineHeight: "15px",
          padding: "0",
      }),
  };

  useEffect(() => {
      const getAssetClass = async () => {
          try {
              const data = await fetchWrapper(
                  `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
                  {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify({}),
                  },
                  navigate
              );

              setAssets(data || []);
              // getEquipment will be called when modal opens with specific equipmentId
          } catch (error) {
              console.error("Error fetching data:", error.message);
              if (error.message === "Unauthorized") {
                  navigate("/auth/login");
              }
          }
      };
      getAssetClass();
  }, [navigate]);

  const getEquipment = async (equipmentId) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/view/${equipmentId}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          // setEquipment(data.data || {});
          setFormValues(data.data || {}); // Set form values with the fetched data
          setRows(data.data.templates || []); // Set rows with the fetched data
          setAssetId(data.data.asset_id); // Set the assetId state
          handleAssetClassChange(data.data.asset_id);
      } catch (error) {
          console.error("Error fetching data:", error.message);
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };
  const handleEditInputChange1 = (id, selectedOption, isDropdown = false) => {
      setEditRowValues((prevValues) => {
          const updatedValue = {
              value: isDropdown
                  ? selectedOption?.label || "" // ✅ store label, not value/id
                  : selectedOption
          };

          return {
              ...prevValues,
              [id]: updatedValue,
          };
      });
  };
  const handleAssetClassChange = async (asset_id) => {
      setAssetId(asset_id);
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/${asset_id}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          setAssetAttributes(data.asset_attributes || []);

          try {
              await getAssetTemplates(asset_id);
          } catch (error) {
              console.error("Error fetching asset templates:", error.message);
              toast.error("Failed to fetch asset templates.");
          }

          try {
              await getAssetMasters(asset_id);
          } catch (error) {
              console.error("Error fetching asset masters:", error.message);
              toast.error("Failed to fetch asset masters.");
          }
      } catch (error) {
          console.error("Error fetching data:", error.message);
          toast.error("An error occurred while fetching data.");
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };

  const getAssetTemplates = async (asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-templates/${asset_id}/attributes`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );
          setAssetTemplates(data || []);

          // Fetch template masters for each template
          const templateMastersPromises = data.map((template) =>
              getTemplateMasters(template, asset_id)
          );

          // Wait for all template masters promises to resolve
          const templateMastersData = await Promise.all(templateMastersPromises);

          // Create a map of template masters
          const templateMastersMap = data.reduce((acc, template, index) => {
              acc[template._id] = templateMastersData[index];
              return acc;
          }, {});

          // Set template masters state
          setTemplateMasters(templateMastersMap);
      } catch (error) {
          console.error("Error fetching data:", error.message);
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };

  const getTemplateMasters = async (template, asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${template._id}/leaf-group`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      asset_id,
                  }),
              },
              navigate // Include navigate if needed for error handling
          );

          return data.data || []; // Ensure data is an array, handle null case
      } catch (error) {
          console.error("Error fetching data:", error.message);
          if (error.message === "Unauthorized") {
              navigate("/auth/login"); // Navigate to login if unauthorized
          }
          return []; // Handle error gracefully, return empty array or default value
      }
  };
  const getAssetMasters = async (asset_id) => {
      try {
          const data = await fetchWrapper(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-masters/${asset_id}`,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({}),
              },
              navigate
          );

          setAssetMasters(data.data || []);
      } catch (error) {
          console.error("Error fetching asset masters:", error.message);
          if (error.message === "Unauthorized") {
              navigate("/auth/login");
          }
      }
  };
  const handleInputChange = (e) => {
      const { name, value, type, files } = e.target;
      setFormValues((prevValues) => ({
          ...prevValues,
          [name]: type === "file" ? files[0] : value,
      }));
  };

  const handleSelectChange = (templateId, masterId, value, text) => {
      setSelectedValues((prevValues) => ({
          ...prevValues,
          [templateId]: {
              ...prevValues[templateId],
              [masterId]: { value, text },
          },
      }));
  };

  const handleAttributeChange = (templateId, attributeId, value) => {
      setSelectedValues((prevValues) => ({
          ...prevValues,
          [templateId]: {
              ...prevValues[templateId],
              [attributeId]: { value },
          },
      }));
  };

  const validateRow = (templateId, assetTemplate) => {
      const selected = selectedValues[templateId] || {};
      let isValid = true;
      const newErrors = {};

      // Check all templateMasters fields
      if (templateMasters[templateId]) {
          templateMasters[templateId].forEach((templateMaster) => {
              if (
                  !selected[templateMaster.master_id] ||
                  !selected[templateMaster.master_id].value
              ) {
                  isValid = false;
                  newErrors[
                      templateMaster.master_id
                  ] = `${templateMaster.master_name} is required`;
              }
          });
      }

      // Check all attribute fields
      assetTemplate.attributes.forEach((attribute) => {
          if (!selected[attribute._id] || !selected[attribute._id].value) {
              isValid = false;
              newErrors[attribute._id] = `${attribute.display_name} is required`;
          }
      });

      if (!isValid) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...prevErrors[templateId],
                  ...newErrors,
                  general: "",
              },
          }));
      } else {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {},
          }));
      }

      return isValid;
  };

  const handleAddClick = (templateId, assetTemplate) => {
      const currentRows = rows[templateId] || [];

      const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
      const selectedFirstDropdownValue = selectedValues[templateId]?.[firstTemplateMasterId]?.value;

      const duplicateFound = currentRows.some(
          (row) => row?.[firstTemplateMasterId]?.value === selectedFirstDropdownValue
      );

      if (duplicateFound) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...(prevErrors[templateId] || {}),
                  [firstTemplateMasterId]: "This value is already taken.",
              },
          }));
          return;
      }

      if (currentRows.length < parseInt(assetTemplate.rowlimit)) {
          if (validateRow(templateId, assetTemplate)) {
              setRows((prevRows) => ({
                  ...prevRows,
                  [templateId]: [...currentRows, selectedValues[templateId]],
              }));

              setSelectedValues((prevValues) => ({
                  ...prevValues,
                  [templateId]: {},
              }));

              resetFormFields(templateId);

              // clear error after successful add
              setErrors((prevErrors) => ({
                  ...prevErrors,
                  [templateId]: {
                      ...(prevErrors[templateId] || {}),
                      [firstTemplateMasterId]: undefined,
                  },
              }));
          }
      } else {
          toast.error(`Row limit of ${assetTemplate.rowlimit} reached`);
      }
  };

  const resetFormFields = (templateId) => {
      const inputs = document.querySelectorAll(`.row-${templateId} input`);
      const selects = document.querySelectorAll(`.row-${templateId} select`);
      inputs.forEach((input) => (input.value = ""));
      selects.forEach((select) => (select.value = ""));
  };

  const handleDeleteClick = (e, templateId, rowIndex) => {
      e.preventDefault();
      setRows((prevRows) => ({
          ...prevRows,
          [templateId]: prevRows[templateId].filter(
              (_, index) => index !== rowIndex
          ),
      }));
  };
  const handleEditInputChange = (id, selectedOption, isDropdown = false) => {
      setEditRowValues((prevValues) => {
          const updatedValues = {
              ...prevValues,
              [id]: {
                  value: isDropdown ? selectedOption?.value || "" : selectedOption,
                  // Only include the label if it's a dropdown; otherwise, omit it
                  ...(isDropdown && { label: selectedOption?.label || "" }),
              },
          };

          return updatedValues;
      });
  };

  const handleEditClick = (templateId, rowIndex, assetTemplate) => {
      const row = rows[templateId][rowIndex];
      setEditRowTemplateId(templateId);
      setEditRowIndex(rowIndex);
      setEditRowValues(() => {
          const initialValues = {};

          // Process templateMasters for dropdowns
          templateMasters[templateId].forEach((templateMaster) => {
              if (row[templateMaster.master_id]) {
                  initialValues[templateMaster.master_id] = {
                      value: row[templateMaster.master_id].value,
                      label: row[templateMaster.master_id].text || "", // Ensure text is used if available
                  };
              }
          });

          // Process attributes for text inputs
          assetTemplate.attributes.forEach((attribute) => {
              if (row[attribute._id]) {
                  initialValues[attribute._id] = {
                      value: row[attribute._id].value,
                      // label: row[attribute._id].text || row[attribute._id].label || "", // Use text or label if available
                  };
              }
          });

          return initialValues;
      });
  };
  const handleSaveClick = (templateId, e) => {
      e.preventDefault();

      const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
      const editedFirstDropdownValue = editRowValues[firstTemplateMasterId]?.value;

      // check if that value exists in other rows
      const duplicateFound = rows[templateId].some((row, idx) => {
          return (
              idx !== editRowIndex &&
              row?.[firstTemplateMasterId]?.value === editedFirstDropdownValue
          );
      });

      if (duplicateFound) {
          setErrors((prevErrors) => ({
              ...prevErrors,
              [templateId]: {
                  ...(prevErrors[templateId] || {}),
                  [editRowIndex]: {
                      ...(prevErrors[templateId]?.[editRowIndex] || {}),
                      [firstTemplateMasterId]: "This value is already taken.",
                  },
              },
          }));
          return;
      }

      const updatedRows = rows[templateId].map((row, index) => {
          if (index === editRowIndex) {
              const updatedRow = { ...row };
              for (const key in editRowValues) {
                  updatedRow[key] = {
                      value: editRowValues[key].value,
                      text: editRowValues[key].label,
                  };
              }
              return updatedRow;
          }
          return row;
      });

      setRows((prevRows) => ({
          ...prevRows,
          [templateId]: updatedRows,
      }));

      // clear error after save
      setErrors((prevErrors) => ({
          ...prevErrors,
          [templateId]: {
              ...(prevErrors[templateId] || {}),
              [editRowIndex]: {},
          },
      }));

      // Reset after saving
      setEditRowTemplateId(null);
      setEditRowIndex(null);
      setEditRowValues({});
  };





  const renderFormField = (attribute) => {
      return (
          <div
              key={attribute._id}
              className="col d-flex flex-column addEuipment-form-col"
          >
              <label htmlFor={attribute.field_name} className="addEuipment-form-text">
                  {attribute.display_name}
                  <span style={{ color: "#dc3545" }}>{attribute.required && " *"}</span>
              </label>
              {errors[attribute.field_name] && (
                  <div
                      className="error mt-2"
                      style={{ color: "#dc3545", marginLeft: "8px" }}
                  >
                      {errors[attribute.field_name]}
                  </div>
              )}
          </div>
      );
  };



  const groupedItems = [];
  for (let i = 0; i < assetAttributes.length; i += 2) {
      groupedItems.push(assetAttributes.slice(i, i + 2));
  }
  const handleOpenuploadModal = (isOpen, templateId, templatename) => {
      setShowUploadModal(isOpen);
      setSelectedTemplateId(templateId);
      setSelectedTemplateName(templatename)// Store the template ID in state
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const handleCloseUploadModal = () => {
      setErrorMessages("");
      setErrorrowMessages("");
      setShowUploadModal(false);
      setSelectedFile(null); // Clear the selected file
  };







  const fetchMasterValues = async (masterId) => {
      try {
          const response = await fetch(
              `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-masters`,
              {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ masterId }),
              }
          );
          if (!response.ok) throw new Error("Failed to fetch master values");
          const data = await response.json();
          return data || []; // return the array directly, no data.data
      } catch (error) {
          console.error("Error fetching master values:", error);
          return [];
      }
  };

  useEffect(() => {
      const loadAllMasterOptions = async () => {
          const newMap = {};

          for (const template of assetTemplates) {
              for (const attr of template.attributes) {
                  if (attr.master_id && !newMap[attr.master_id]) {
                      const options = await fetchMasterValues(attr.master_id);
                      newMap[attr.master_id] = options;
                  }
              }
          }

          setMasterOptionsMap(newMap);
      };

      loadAllMasterOptions();
  }, [assetTemplates]);
  // ------------------------------------------

  useEffect(() => {
    const getUsecases = async () => {
      try {
        const data = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-usecase`,
          { method: "POST", body: JSON.stringify({}) }
        );

        const usecase_id = data._id;
        const result = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/templates/type/${usecase_id}`,
          { method: "POST", body: JSON.stringify({}) }
        );
        setUsecases(result.templates || []);
      } catch (error) {
        if (error.message === "Unauthorized") navigate("/auth/login");
      }
    };
    getUsecases();
  }, [navigate]);

  const fetchAllEquipments = async () => {
    setLoading(true);
    try {
      const equipmentResponse = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
        { method: "POST", body: JSON.stringify({}) }
      );
      return equipmentResponse.data || [];
    } catch (error) {
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Only load usecases initially, not equipment data
    // Equipment data will be loaded when a usecase is selected
  }, []);

const fetchUsecaseData = async (selectedUsecase) => {
  if (!selectedUsecase || !selectedUsecase._id) return;
  setLoading(true);

  try {
    // First load equipment data when usecase is selected
      const equipments = await fetchAllEquipments();
    let processedEquipments = [];
    
      if (equipments && equipments.length > 0) {
      processedEquipments = equipments.map((eqpt) => {
          const equipmentTagValues = [];
          if (eqpt.templates && typeof eqpt.templates === "object") {
            Object.values(eqpt.templates).forEach((templateArray) => {
              if (Array.isArray(templateArray)) {
                templateArray.forEach((attributeObj) => {
                  if (attributeObj && typeof attributeObj === "object") {
                    Object.values(attributeObj).forEach((tag) => {
                      if (tag && tag.text) {
                        equipmentTagValues.push(tag.text);
                      }
                    });
                  }
                });
              }
            });
          }
          
          const numberOfTags = equipmentTagValues.length;
          
          return {
            _id: eqpt._id,
            equipment_code:
              eqpt.equipment_code || eqpt.equipment_name || eqpt._id,
            equipment_name: eqpt.equipment_name || "Unknown",
            capacity: eqpt.capacity || "N/A",
            numberOfTags: numberOfTags,
            totalConfigured: 0,
            matchCount: 0, 
            percentMatch: "0.00",
            matchedSpvs: [],
            fullData: eqpt,
          };
        });
      }

    const templateId = selectedUsecase._id;
    
    const templateMastersResponse = await fetchWrapper(
      `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${templateId}`,
      { method: "POST", body: JSON.stringify({}) }
    );
    const templateMasters = templateMastersResponse.data || [];
    
    if (templateMasters.length === 0) {
      alert("Kindly enter template masters for the selected template.");
      return;
    }
    
    // Filter ONLY for exact "Standard Process Variables" - no linked items
      const spvMasters = templateMasters.filter(
      (master) => master.master_name === "Standard Process Variables" && master.leaf_node === true
    );
    
    if (spvMasters.length === 0) {
        alert(
          "No 'Standard Process Variables' found for this template. Kindly configure template masters."
        );
      return;
    }

    // Split comma-separated document_codes into individual SPV codes for matching
    const useCaseSpvCodes = [];
    spvMasters.forEach((master) => {
      if (master.document_code) {
        // Split by comma and trim whitespace
        const codes = master.document_code.split(',').map(code => code.trim());
        useCaseSpvCodes.push(...codes);
      }
    });
    
    // Group by template_id and then extract unique base names within each group
    const groupedByTemplateId = {};
    spvMasters.forEach(master => {
      const templateId = master.template_id;
      if (!groupedByTemplateId[templateId]) {
        groupedByTemplateId[templateId] = [];
      }
      groupedByTemplateId[templateId].push(master);
    });
    
    // Count unique base names within each template_id group
    let totalUniqueBaseNames = 0;
    const allUniqueBaseNames = new Set();
    
    Object.keys(groupedByTemplateId).forEach(templateId => {
      const mastersInTemplate = groupedByTemplateId[templateId];
      
      // Extract base names for this template
      const baseNamesInTemplate = mastersInTemplate.map(master => {
        const documentCode = master.document_code;
        
        // Remove ALL prefixes (FILES-CSV-, RDBMS-CSV-, etc.) to get the true base name
        let baseName = documentCode;
        
        // Remove first prefix (FILES-, RDBMS-, CLOUD-, OPC-)
        if (baseName.includes('-')) {
          baseName = baseName.substring(baseName.indexOf('-') + 1);
        }
        
        // Remove second prefix (CSV-, XML-, JSON-, etc.) if exists
        if (baseName.includes('-')) {
          baseName = baseName.substring(baseName.indexOf('-') + 1);
        }
        
        return baseName;
      });
      
      // Get unique base names for this template
      const uniqueBaseNamesInTemplate = [...new Set(baseNamesInTemplate)];
      totalUniqueBaseNames += uniqueBaseNamesInTemplate.length;
      
      // Also track all unique base names globally
      uniqueBaseNamesInTemplate.forEach(baseName => allUniqueBaseNames.add(baseName));
    });
    
    const useCaseSpvCount = totalUniqueBaseNames;
    
    // Keep original document codes for matching
    const uniqueDocumentCodes = [...new Set(spvMasters.map(master => master.document_code))];

      const spvMasterMapping = {};
      spvMasters.forEach((master) => {
        spvMasterMapping[master.document_code] = master.mapped_value || "N/A";
      });
      setSpvMappings(spvMasterMapping);

    const updatedEquipments = processedEquipments.map((equipment, index) => {
      // Extract equipment tags
      const equipmentTags = [];
        if (
          equipment.fullData &&
          equipment.fullData.templates &&
          typeof equipment.fullData.templates === "object"
        ) {
          Object.values(equipment.fullData.templates).forEach((templateArray) => {
          if (Array.isArray(templateArray)) {
              templateArray.forEach((attributeObj) => {
                if (attributeObj && typeof attributeObj === "object") {
                  Object.values(attributeObj).forEach((tag) => {
                  if (tag && tag.text) {
                    equipmentTags.push(tag.text);
                  }
                });
              }
            });
          }
        });
      }
      
      // Use the same logic as usecase count: group by template_id and check unique base names
      const matchedUniqueBaseNames = new Set(); // Track unique base names that match (across all templates)
      let totalMatchedBaseNames = 0; // Count unique base names per template
      
      Object.keys(groupedByTemplateId).forEach(templateId => {
        const mastersInTemplate = groupedByTemplateId[templateId];
        const templateMatchedBaseNames = new Set(); // Track unique base names for this template
        
        mastersInTemplate.forEach(master => {
          const documentCode = master.document_code;
          
          // Apply same double prefix removal as in usecase count
          let baseName = documentCode;
          
          // Remove first prefix (FILES-, RDBMS-, CLOUD-, OPC-)
          if (baseName.includes('-')) {
            baseName = baseName.substring(baseName.indexOf('-') + 1);
          }
          
          // Remove second prefix (CSV-, XML-, JSON-, etc.) if exists
          if (baseName.includes('-')) {
            baseName = baseName.substring(baseName.indexOf('-') + 1);
          }
          
          // Method 1: Check if any equipment tag contains the complete document_code (with prefixes)
          const tagContainsComplete = equipmentTags.some(tag => tag.includes(documentCode));
          
          // Method 2: Check if any equipment tag contains the base name (without prefixes)
          const tagContainsBaseName = equipmentTags.some(tag => tag.includes(baseName));
          
          // Method 3: Split base name and check if all parts are present in equipment tags
          const baseParts = baseName.split(',').map(part => part.trim());
          const allBasePartsPresent = baseParts.every(part => 
            equipmentTags.some(tag => tag.includes(part))
          );
          
          // Consider it a match if any condition is true
          if (tagContainsComplete || tagContainsBaseName || allBasePartsPresent) {
            templateMatchedBaseNames.add(baseName); // Track for this template
            matchedUniqueBaseNames.add(baseName); // Track globally
          }
        });
        
        // Add unique base names count from this template
        totalMatchedBaseNames += templateMatchedBaseNames.size;
      });
      
      // Use same counting logic as usecase count
      const matchCount = totalMatchedBaseNames;
      
        const percentMatch =
          useCaseSpvCount > 0
        ? ((matchCount / useCaseSpvCount) * 100).toFixed(2) 
        : "0.00";
      
      return {
        ...equipment,
        // Keep original numberOfTags (ALL tags regardless of usecase)
        totalConfigured: useCaseSpvCount,
        matchCount: matchCount,
          percentMatch: percentMatch,
          matchedSpvs: [...matchedUniqueBaseNames], // Use unique base names for consistency
      };
    });

    setGroupedData(updatedEquipments);
      setPage(1);
    setCurrentPage(1);
  } catch (error) {
      alert("Error fetching template masters. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleview = async (equipmentId) => {
    const equipment = groupedData.find((eq) => eq._id === equipmentId);
    if (equipment) {
      setSelectedEquipment(equipment);
      setShowModal(true);
      // Fetch equipment details for the modal
      await getEquipment(equipmentId);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEquipment(null);
  };

  // Temporarily show all equipment for debugging
  const filteredData = groupedData; // .filter((item) => item.matchCount > 0);

  const indexOfLastItem = page * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    setTotalItems(filteredData.length);
    setTotalPages(Math.ceil(filteredData.length / pageSize));
  }, [groupedData, pageSize]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      setPage(newPage);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
    setCurrentPage(1);
  };

  const renderTableData = () => {
    // Show message when no usecase is selected
    if (!selectedUsecase) {
      return (
        <tr>
          <td colSpan="7" className="text-center py-5">
            <div className="d-flex flex-column align-items-center">
              <i className="fas fa-list-alt fa-3x text-muted mb-3"></i>
              <h6 className="text-muted mb-2">Select a Usecase</h6>
              <p className="text-muted mb-0">
                Please select a usecase from the dropdown above to view equipment SPV analysis.
              </p>
            </div>
          </td>
        </tr>
      );
    }
    
    if (!filteredData.length) {
      return (
        <tr>
          <td colSpan="7" className="text-center">
            No data available
          </td>
        </tr>
      );
    }

    return currentItems.map((equipment) => (
      <tr key={equipment._id}>
        <td>{equipment.equipment_code || "N/A"}</td>
        <td>{equipment.equipment_name || "N/A"}</td>
        <td className="text-center">{equipment.numberOfTags || 0}</td>
        <td className="text-center">{equipment.totalConfigured || 0}</td>
        <td className="text-center">{equipment.matchCount}</td>
        <td className="text-center">{equipment.percentMatch}%</td>
        <td className="text-center">
          <button
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
            onClick={() => handleview(equipment._id)}
            title="View"
          >
            <img
              style={{ width: "25px" }}
              src="http://localhost:3000/static/media/visible%201.5c655ed862d974e83e40d70c0bc179f3.svg"
              alt="view"
            />
          </button>
        </td>
      </tr>
    ));
  };

  return (
    <div className="container pt-3">
      <div className="pt-3 pb-0 d-flex justify-content-between">
        <div>
          <h5>Usecase Footprint</h5>
          <nav className="breadcrumb-nav" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#" style={{ textDecoration: "none" }}>
                  Review
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Usecase Footprint
              </li>
            </ol>
          </nav>
        </div>

        <div className="d-flex gap-3">
          <div className="dropdown">
            <select
              id="usecases"
              style={{ padding: "10px", width: "250px" }}
              className="select-unit textarea"
              onChange={async (e) => {
                if (e.target.value === "") {
                  // Clear selection and data when no usecase is selected
                  setSelectedUsecase(null);
                  setGroupedData([]);
                  return;
                }
                const usecase = JSON.parse(e.target.value);
                setSelectedUsecase(usecase);
                await fetchUsecaseData(usecase);
              }}
            >
              <option value="">Select Usecase</option>
              {usecases.map((usecase) => (
                <option key={usecase._id} value={JSON.stringify(usecase)}>
                  {usecase.template_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="table-responsive mt-3">
        <table className="table align-middle table-text">
          <thead className="table-head align-middle">
            <tr>
              <th>Equipment Code</th>
              <th>Equipment Name</th>
              <th>Total Tags Configured</th>
              <th>Usecase Count</th>
              <th>SPV Match Count</th>
              <th>% Match</th>
              <th>View SPVs</th>
            </tr>
          </thead>
          <tbody>{renderTableData()}</tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        pageSize={pageSize}
        onPageSizeChange={handlePageSizeChange}
        totalItems={totalItems}
        startIndex={indexOfFirstItem + 1}
        endIndex={Math.min(indexOfLastItem, totalItems)}
      />

      {/* Variables Modal */}
      {showModal && selectedEquipment && (
        <div
          id="overlay"
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="addunit-card" style={{ width: "95%", maxWidth: "100%", height: "95vh" }}>
            <div className="addunit-header">
              <h4>Variables</h4>
              <button
                style={{ border: "none", backgroundColor: "inherit" }}
                type="button"
                className="close"
                onClick={handleCloseModal}
              >
                <img src={closeIcon} width="28px" height="28px" alt="Close" />
              </button>
            </div>
            <div className="addunit-form" style={{ maxHeight: "calc(95vh - 120px)", overflowY: "auto" }}>
                <div className="container">
                  <div className="row mb-4">
                    <div className="d-flex justify-content-between align-items-center col-sm-12 mb-2">
                      <h5 className="mb-1">SPV Match Details</h5>
              </div>
                    <div className="table-responsive">
                       <table className="table align-middle table-text">
                           <thead className="table-head align-middle">
                               <tr>
                                   <th className="text-center">#</th>
                            <th className="text-uppercase">Matched SPV</th>
                            <th className="text-uppercase">Equipment Tags</th>
                            <th className="text-uppercase">Minimum Value</th>
                            <th className="text-uppercase">Maximum Value</th>
                            <th className="text-uppercase">Lower Control Limit</th>
                            <th className="text-uppercase">Upper Control Limit</th>
                            <th className="text-uppercase">FlatLine Length (min)</th>
                            <th className="text-uppercase">PI Tag ID</th>
                                   <th className="text-uppercase">PI WEB ID</th>
                                   <th className="text-uppercase">KM Tag ID</th>
                                   <th className="text-uppercase">KM RI Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const matchedSpvs = selectedEquipment?.matchedSpvs || [];
                            
                            if (matchedSpvs.length === 0) {
                              return (
                                <tr>
                                  <td colSpan="11" className="text-center py-5">
                                    <div className="d-flex flex-column align-items-center">
                                      <i className="fas fa-search fa-3x text-muted mb-3"></i>
                                      <h6 className="text-muted mb-2">No Matched SPVs Found</h6>
                                      <p className="text-muted mb-0">
                                        No Standard Process Variables matched the equipment tags for the selected usecase.
                                      </p>
                                               </div>
                                           </td>
                                       </tr>
                              );
                            }
                            
                            return matchedSpvs.map((spv, index) => {
                              // Find equipment tags and attribute values that match this SPV
                              const equipmentTags = [];
                              let attributeValues = {
                                minimumValue: '',
                                maximumValue: '',
                                lowerControlLimit: '',
                                upperControlLimit: '',
                                flatlineLength: '',
                                piTagId: '',
                                piWebId: '',
                                kmTagId: '',
                                kmRiCode: ''
                              };
                              
                              // Create attribute mapping based on display names
                              const attributeMapping = {};
                              if (assetTemplates && Array.isArray(assetTemplates)) {
                                assetTemplates.forEach(template => {
                                  if (template.attributes && Array.isArray(template.attributes)) {
                                    template.attributes.forEach(attr => {
                                      const displayName = attr.display_name?.toLowerCase() || '';
                                      if (displayName.includes('minimum') && displayName.includes('value')) {
                                        attributeMapping.minimumValue = attr._id;
                                      } else if (displayName.includes('maximum') && displayName.includes('value')) {
                                        attributeMapping.maximumValue = attr._id;
                                      } else if (displayName.includes('lower') && displayName.includes('control')) {
                                        attributeMapping.lowerControlLimit = attr._id;
                                      } else if (displayName.includes('upper') && displayName.includes('control')) {
                                        attributeMapping.upperControlLimit = attr._id;
                                      } else if (displayName.includes('flatline')) {
                                        attributeMapping.flatlineLength = attr._id;
                                      } else if (displayName.includes('pi') && displayName.includes('tag') && !displayName.includes('web')) {
                                        attributeMapping.piTagId = attr._id;
                                      } else if (displayName.includes('pi') && displayName.includes('web')) {
                                        attributeMapping.piWebId = attr._id;
                                      } else if (displayName.includes('km') && displayName.includes('tag')) {
                                        attributeMapping.kmTagId = attr._id;
                                      } else if (displayName.includes('km') && displayName.includes('ri')) {
                                        attributeMapping.kmRiCode = attr._id;
                                      }
                                    });
                                  }
                                });
                              }
                              
                              // Search through rows data to find matching SPV and extract values
                              if (rows && typeof rows === 'object') {
                                Object.entries(rows).forEach(([templateId, templateRows]) => {
                                  if (Array.isArray(templateRows)) {
                                    templateRows.forEach((row) => {
                                      if (row && typeof row === "object") {
                                        // Check if this row contains the matched SPV
                                        let hasMatchingTag = false;
                                        
                                        // Search through all fields in the row to find tags
                                        Object.entries(row).forEach(([fieldKey, field]) => {
                                          if (field && field.text) {
                                            if (field.text.includes(spv)) {
                                              hasMatchingTag = true;
                                              if (!equipmentTags.includes(field.text)) {
                                                equipmentTags.push(field.text);
                                              }
                                            }
                                          }
                                        });
                                        
                                        // If this row has a matching tag, extract attribute values using the mapping
                                        if (hasMatchingTag) {
                                          // Use attribute mapping to get correct values
                                          if (attributeMapping.minimumValue && row[attributeMapping.minimumValue]) {
                                            attributeValues.minimumValue = row[attributeMapping.minimumValue]?.text || row[attributeMapping.minimumValue]?.value || '';
                                          }
                                          if (attributeMapping.maximumValue && row[attributeMapping.maximumValue]) {
                                            attributeValues.maximumValue = row[attributeMapping.maximumValue]?.text || row[attributeMapping.maximumValue]?.value || '';
                                          }
                                          if (attributeMapping.lowerControlLimit && row[attributeMapping.lowerControlLimit]) {
                                            attributeValues.lowerControlLimit = row[attributeMapping.lowerControlLimit]?.text || row[attributeMapping.lowerControlLimit]?.value || '';
                                          }
                                          if (attributeMapping.upperControlLimit && row[attributeMapping.upperControlLimit]) {
                                            attributeValues.upperControlLimit = row[attributeMapping.upperControlLimit]?.text || row[attributeMapping.upperControlLimit]?.value || '';
                                          }
                                          if (attributeMapping.flatlineLength && row[attributeMapping.flatlineLength]) {
                                            attributeValues.flatlineLength = row[attributeMapping.flatlineLength]?.text || row[attributeMapping.flatlineLength]?.value || '';
                                          }
                                          if (attributeMapping.piTagId && row[attributeMapping.piTagId]) {
                                            attributeValues.piTagId = row[attributeMapping.piTagId]?.text || row[attributeMapping.piTagId]?.value || '';
                                          }
                                          if (attributeMapping.piWebId && row[attributeMapping.piWebId]) {
                                            attributeValues.piWebId = row[attributeMapping.piWebId]?.text || row[attributeMapping.piWebId]?.value || '';
                                          }
                                          if (attributeMapping.kmTagId && row[attributeMapping.kmTagId]) {
                                            attributeValues.kmTagId = row[attributeMapping.kmTagId]?.text || row[attributeMapping.kmTagId]?.value || '';
                                          }
                                          if (attributeMapping.kmRiCode && row[attributeMapping.kmRiCode]) {
                                            attributeValues.kmRiCode = row[attributeMapping.kmRiCode]?.text || row[attributeMapping.kmRiCode]?.value || '';
                                          }
                                        }
                                      }
                                    });
                                  }
                                });
                              }
                              
                              return (
                                <tr key={index}>
                                  <td className="text-center">
                                    <strong className="text-muted">{index + 1}</strong>
                                           </td>
                                  <td>
                                    <strong className="text-primary">{spv}</strong>
                                  </td>
                                  <td>
                                    <div className="d-flex flex-column" style={{maxWidth: '200px'}}>
                                      {equipmentTags.length > 0 ? (
                                        <>
                                          <span className="fw-semibold text-muted">{equipmentTags[0]}</span>
                                          {equipmentTags.length > 1 && (
                                            <small className="text-muted">
                                              +{equipmentTags.length - 1} more tags
                                            </small>
                                          )}
                                        </>
                                      ) : (
                                        <span className="text-muted">N/A</span>
                                      )}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.minimumValue || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.maximumValue || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.lowerControlLimit || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.upperControlLimit || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.flatlineLength || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.piTagId || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.piWebId || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.kmTagId || '-'}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="fw-semibold text-muted">
                                      {attributeValues.kmRiCode || '-'}
                                    </span>
                                  </td>
                                </tr>
                              );
                            });
                          })()}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

             
            </div>
        </div>
      )}
    </div>
  );
};

export default UsageReview;
